import React from 'react';
import {Text, Button, Icon, Heading} from '@albert-io/atomic';

export const ContentBlocker = () => {
  return (
    <div className='question-content-blocker mt-x4'>
      <div className='question-content-blocker__icon-wrapper'>
        <Icon icon='lock' className='question-content-blocker__lock-icon' size='inherit' />
      </div>
      <div className='question-content-blocker__description mt-x2'>
        <Heading size='l'>Unlock all content and features!</Heading>
        <Text size='l' as='ul' bold color='inherit' className='view-license-options__list my-x2'>
          <li>
            For schools and districts -- Unlock all features + questions banks for AP, SAT, ACT,
            state exams, electives, languages, and more.
          </li>
          <li>For students -- Get access to the best human-written test prep questions.</li>
          <li>For homeschools -- Support all areas of your teaching.</li>
          <li>All licensed backed by world-class responsive support</li>
          <li>Paid trainings available for school and district customers</li>
        </Text>
      </div>
      <div className='mt-x6 flex flex-wrap gap-x1'>
        <Button
          as='a'
          href='/pricing-schools'
          roundness='pill'
          className='view-license-options w-full grow'
        >
          <Icon icon='sparkles' className='mr-x1' />
          Explore Educator Licenses
        </Button>
        <Button
          as='a'
          href='/pricing-students'
          color='blend-dark'
          roundness='pill'
          className='view-license-options flex-1'
        >
          Purchase Individual Access
        </Button>
        <Button
          as='a'
          href='/pricing-homeschools'
          color='blend-dark'
          roundness='pill'
          className='view-license-options flex-1'
        >
          Explore Homeschool and Tutoring Licenses
        </Button>
      </div>
      <Icon icon='sparkles' className='question-content-blocker__icon--sparkles' />
    </div>
  );
};
